import GenericController from './../generic.controller'
import usa from "../../../../images/usa.png";

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.userId = this.$stateParams.id;
        this.notificationsAddresses = [];
        this.getEmailNotification();
        this.notificationsFilterText = [this.gettext('alarm'), this.gettext('configuration'), this.gettext('information')
            , this.gettext('take_picture'), this.gettext('user_association'), this.gettext('arm'),
            this.gettext('troubles'), this.gettext('receive_pictures')];
        this.notificationsFilter = {};
        this.receivePictures = {};
        this.NOTIFICATION_LANGUAGES = [
            {name: 'English(US)', shortcut: 'en'},
            {name: 'Français', shortcut: 'fr'},
            {name: 'Deutsch', shortcut: 'de'},
            {name: 'Русский', shortcut: 'ru'},
            {name: 'Čeština', shortcut: 'cs'},
            {name: 'Português', shortcut: 'pt'},
            {name: 'Türkçe', shortcut: 'tr'},
            {name: 'Dansk', shortcut: 'da'},
            {name: 'עברית', shortcut: 'he'},
            {name: 'Ελληνικά', shortcut: 'el'},
            {name: 'Italiano', shortcut: 'it'},
            {name: 'Norsk', shortcut: 'nn'},
            {name: 'Español', shortcut: 'es'},
            {name: 'Slovenčina', shortcut: 'sk'},
            {name: 'Română', shortcut: 'ro'},
            {name: 'български', shortcut: 'bg'},
            {name: 'Svenska', shortcut: 'sv'},
            {name: 'Suomi', shortcut: 'fi'},
            {name: 'Magyar', shortcut: 'hu'},
            {name: 'Polski', shortcut: 'pl'},
        ];
        this._PanelsService.getPanelById(this.userId).then((resp) => {

            this.panelObject = resp.data;
            this.email = this.panelObject.user.email;
            this.notificationsFilter = this.panelObject.notifications_filter;
            this.receivePictures['receive_pictures'] = this.panelObject.receive_pictures;
            this.mac = this.panelObject.control_panel.mac;
            this.panelName = this.panelObject.name;
        });

        this.$element.on('$destroy', () => {
            this.closeModal('deleteEmailYesNoModal');
        });
    }

    submit() {
        this._PanelsService.setPanelNotifications(this.mac, this.panelName, this.userId,
            this.notificationsFilter, this.receivePictures.receive_pictures, this.panelObject.notification_language)
            .then(() => {
                this.toaster.pop("success", "Success", "Notifications saved");
            })
            .catch(() => {
                this.toaster.pop("error", "Error", "Something went wrong please try again later");
            })
    }

    getEmailNotification() {
        this.loading = true;
        this._PanelsService.getEmailNotification(this.panelId).then(r => {

            this.notificationsAddresses = r.data.results;
            this._setEmailNotificationObjects();
        })
            .catch(r => console.log(r))

            .finally(r => {
                    this.loading = false;
                }
            )
    }

    addEmailNotification(emailObject) {

        let isEmailValid = this.isEmailAddressValid(this.currentEmailAddress)

        if (isEmailValid && !emailObject.hasOwnProperty('id')) {
            this.loading = true;
            this._PanelsService.addEmailNotification(this.panelId, this.currentEmailAddress).then(r => {

                this.getEmailNotification();

            })
                .catch(r => console.log(r))
                .finally(() => {
                        this.loading = false;
                    }
                )
        } else if (isEmailValid) {

            this.loading = true;
            this._PanelsService.setEmailNotification(this.panelId, emailObject['id'], this.currentEmailAddress).then(r => {

                // console.log(this.notificationsAddresses);
            })
                .catch(r => console.log(r))
                .finally(r => {
                        this.loading = false;
                    }
                )

        } else if (!isEmailValid) {

            this.deleteEmailNotification();
            this.notificationsAddresses.splice(-1, 1);
        }
    }

    _setEmailNotificationObjects() {

        for (let i = 0; i < this.notificationsAddresses.length; i++) {

            this.notificationsAddresses[i].uiId = i + 1;

        }
    }

    isEmailAddressValid(emailAddress) {

        return typeof emailAddress != 'undefined' && emailAddress != ''
    }

    deleteEmailNotification() {

        if (this.notificationsAddresses[this.uiIndex]['id']) {
            this.loading = true;
            this._PanelsService.deleteEmailNotification(this.panelId, this.currentEmailId).then(r => {

                this.notificationsAddresses = r.data.results;
                this.getEmailNotification();
            })
                .catch(r => console.log(r))

                .finally(r => {
                        this.loading = false;
                    }
                )
        } else {

            this.removeEmailByUiIndex(this.uiIndex);
            this.getEmailNotification();
        }
    }

    popDeleteMOdal() {
        this.showModal('deleteEmailYesNoModal');
    }

    setCurrentEmailRow(emailId, emailAddress, uiIndex) {
        this.currentEmailId = emailId;
        this.currentEmailAddress = emailAddress;
        this.uiIndex = uiIndex;
    }

    removeEmailByUiIndex(uiIndex) {
        this.notificationsAddresses.splice(uiIndex - 1, 1);

    };

    onCancelEditEmail(email) {

        if (!email.key) {
            this.removeEmailByUiIndex(email.uiId);
            this._setEmailNotificationObjects();
        }

    }

    addEmail() {

        this.inserted = {
            uiId: this.notificationsAddresses.length + 1,
            key: '',
        };
        this.notificationsAddresses.push(this.inserted);
    };
}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/notifications.component/controller.js
 **/